import { render } from "./SelectDay.vue?vue&type=template&id=5bf234b2"
import script from "./SelectDay.vue?vue&type=script&lang=js"
export * from "./SelectDay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__